import {  Typography, Paper, CardContent, Card, TableContainer, Table, TableBody, TableCell, TableRow } from "@mui/material";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import { useNavigate } from "react-router-dom";
import { TitleBarProps } from "../../../../../shared/components/titleBar";
import { ViewContainer } from "../../../../../shared/components/viewContainer";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";
import DataTable from "../../../../../shared/components/dataTable";
import { useContext, useState } from "react";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";
import Loader from "../../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import { LoadingButton } from "@mui/lab";
import useMutation from "../../../../../shared/components/hooks/useMutation";



const PaymentHistory = () => {

  const navigate = useNavigate();
  const studentId = localStorage.getItem("selectedStudentId");
  const { payload, setPayload } = useContext(SidebarContext);
const [loadingRowId, setLoadingRowId] = useState<string | null>(null);

   const { loading: apiLoading, modifyData } = useMutation();
  const updateStatus = async (transactionID: string) => {
 setLoadingRowId(transactionID);
      const payload = {
      transactionID: transactionID,
    };

    const response = await modifyData(
      "/payment-gateway/retrieve-payment",
      "post",
      payload
    );
    if(response)
    {
      fetchData();
      setLoadingRowId(null);
    }
   
  }
  

    const { loading, data, fetchData, error } = useQuery("/transactions", {
    params: {
      ...payload,
      studentID: studentId , 
    },
  });
  const paymentHistory = (data as any) || [];

//   if (loading) return <Typography>Loading payment history...</Typography>;
//   if (error) return <Typography color="error">Error fetching payment history</Typography>;

//   if (paymentHistory.totalItems === 0) {
//     return <Typography>No payment records found for this student.</Typography>;
//   }

   const titleBar: TitleBarProps = {
      title: "Payment History",
      editCloseIcon: {
        visible: true,
        onClick: () => navigate(-1),
      },
    };
     const paymentDataItems = paymentHistory?.items?.map((item: any) => ({
        id: item.id,
        term: item.feeTerm.name,
        transactionID: item.paymentGatewayTransactionID,
        paymentDate: new Date(item.paymentDate).toLocaleDateString('en-GB'),
        paymentMode:item?.payment?.paymentMode|| 'Online',
        receiptNo:item?.payment?.receiptNumber || 'N/A',
        amount: item.amount.toLocaleString(),
          status:
        item.paymentStatus === "Pending"
          ? (
                 <LoadingButton
                        loading={loadingRowId !== null && loadingRowId === item.transactionID}
                        id="ebz-checkout-btn"
                        variant="contained"
                        color="primary"
                        aria-label="Update Payment Status"
                        onClick={() => updateStatus(item.transactionID)}

                      >
                        Update Status
                      </LoadingButton>
            )
          : item.paymentStatus,
      }));
   
   const historyDisplayColumns = [
    "term",
   "transactionID",
    "paymentDate",
    "paymentMode",
    "receiptNo",
    "amount",
    "status"
  ];

      const historyTitleBar = {
        headerTitle: "Payment History",
        title: "Payment History",
          editCloseIcon: {
      visible: true,
      onClick: () => navigate(-1),
    },
      
        rowCount: paymentHistory?.totalItems,
      };
  return (


 <TableViewContainer titleBar={historyTitleBar}> {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
  <DataTable
          entityName="Payment History"
          data={paymentDataItems}
          displayColumns={historyDisplayColumns}
          linkColumn="name"
          linkUrl=""
          pagination={{ take: payload.take, skip: payload.skip }}
          setPagination={setPayload}
          totalItems={paymentHistory?.totalItems}
          refetchFunction={fetchData}
        />
         )}</TableViewContainer>)
  
};

export default PaymentHistory;
